import { usePut } from '@/core/hooks/useFetch';
import type { ApiResource } from '@future-harry/nxt-styles';
import type { ContentBlock } from '@/modules/content-blocks/interfaces';
import type { JobBoard } from '@/core/collections/job-boards/job-board.interface';
import { PAGES_ENDPOINTS } from './pages.endpoints';

export interface UpdatePageVersionPayload {
   page_id?: number;
   title?: string;
   slug?: string;
   status?: string;
   content_blocks: ContentBlock[];
}

export async function updatePageVersion(jobBoard: JobBoard, contentBlocks: ContentBlock[]) {
   const latestVersion = jobBoard.pages?.[0]?.latest_version;

   if (!latestVersion) {
      throw new Error('NxtJob: No latest page version found for this job board');
   }

   const pageId = latestVersion.page_id;
   const versionId = latestVersion.id;

   const payload: UpdatePageVersionPayload = {
      page_id: latestVersion.page_id,
      title: latestVersion.title,
      slug: latestVersion.slug,
      status: latestVersion.status,
      content_blocks: contentBlocks,
   };

   return usePut<ApiResource<void>>(PAGES_ENDPOINTS.UPDATE_PAGE_VERSION(pageId, versionId), {
      data: payload,
   });
}
